import { motion } from 'framer-motion';
import { money, pct } from '@/services/opportunitiesApi';

/* Barra de progreso de las aportaciones de una operación. */
export default function FundingBar({ progress, currency, size = 'sm', delay = 0 }) {
  const p = progress?.pct ?? 0;
  const full = p >= 100;
  const h = size === 'lg' ? 'h-2.5' : 'h-1.5';
  let detail = null;
  if (full) detail = 'Financiada al 100 %';
  else if (progress?.raised !== null && progress?.raised !== undefined && progress?.target) {
    detail = `${money(progress.raised, currency)} de ${money(progress.target, currency)}`;
  } else if (progress?.target) detail = `Objetivo ${money(progress.target, currency)}`;
  return (
    <div className="space-y-1.5" data-testid="funding-bar">
      <div className="flex items-baseline justify-between gap-2 text-xs">
        <span className="text-gray-400">Aportaciones</span>
        <span className={`font-semibold tabular-nums ${full ? 'text-emerald-300' : 'text-[#e3c87a]'} ${size === 'lg' ? 'text-base' : ''}`}>{pct(p)}</span>
      </div>
      <div className={`w-full ${h} bg-white/[0.07] rounded-full overflow-hidden`} role="progressbar" aria-valuenow={p} aria-valuemin={0} aria-valuemax={100}>
        <motion.div initial={{ width: 0 }} animate={{ width: `${p}%` }} transition={{ duration: 0.9, delay, ease: 'easeOut' }}
          className={`h-full rounded-full ${full ? 'bg-gradient-to-r from-emerald-500 to-emerald-300' : 'bg-gradient-to-r from-[#c9a84c] to-[#e3c87a]'}`} />
      </div>
      {detail && <p className="text-[11px] text-gray-400 tabular-nums">{detail}</p>}
    </div>
  );
}
